import { Spinner as ReactSpinner } from "reactstrap";

export default function Spinner(props:any) {
  return (<ReactSpinner {...props} style={{ display: 'block', margin: 'auto', opacity: 0.6 }} />);
}